/* eslint-disable no-mixed-spaces-and-tabs */
import { Actions, StateChanges } from "./stateChanges"
//import {RunStates} from './runStates'
import { StoreConfig } from "./storeConfig"
import router from "../router"
import {
  BASEFORM_POS_LIST,
  BASEFORM_NUMBER_LIST,
  BASEFORM_GENDER_LIST,
  BASEFORM_PERSON_LIST,
  BASEFORM_STATUS_LIST,
  BASEFORM_TENSE_LIST,
  SUFFIX_GENDER_LIST,
  SUFFIX_NUMBER_LIST,
  SUFFIX_PERSON_LIST,
} from "@/mixins/morphVariables"
import axios from "axios"

const CHARUZIT_SERVER = StoreConfig.SERVER
const SOUNDPLAY_SERVER = StoreConfig.SOUNDPLAY_SERVER
//const TAVNIT_SERVER = StoreConfig.TAVNIT_SERVER

const SUFFIX_LIST = [undefined, true, false]

axios.defaults.headers = {
  "Content-Type": "application/json",
}
const axiosInstance = axios.create({ timeout: 130000 })
var source

export default {
  [Actions.RELOAD_FROM_URL]: function ({ commit, state, dispatch }) {
    /*  if (router.currentRoute.query.tokens0) {
      commit(StateChanges.SET_MODEL, "pattern");
    } */ //else {
    let typeParam = router.currentRoute.query.type
    let searchWord = router.currentRoute.query.search
    if (router.currentRoute.query.semantic) {
      let semanticParam = JSON.parse(
        decodeURIComponent(router.currentRoute.query.semantic)
      )
      if (semanticParam.length > 0) {
        semanticParam.forEach((element) => {
          commit(StateChanges.SET_SEMANTICS, element)
        })
      }
    }
    if (router.currentRoute.query.mode) {
      state.preSubmissionOptions.rhymeMode = router.currentRoute.query.mode
    }
    if (router.currentRoute.query.accent) {
      state.preSubmissionOptions.accent = router.currentRoute.query.accent
    }
    if (router.currentRoute.query.consswap) {
      if (router.currentRoute.query.consswap === "false")
        state.preSubmissionOptions.LetSwapSettings.consonentLetSwap = false
      else state.preSubmissionOptions.LetSwapSettings.consonentLetSwap = true
    }
    if (router.currentRoute.query.vocalswap) {
      if (router.currentRoute.query.vocalswap === "false")
        state.preSubmissionOptions.LetSwapSettings.vocalSwap = false
      else state.preSubmissionOptions.LetSwapSettings.vocalSwap = true
    }
    if (router.currentRoute.query.min_syl) {
      state.preSubmissionOptions.minSyllable = router.currentRoute.query.min_syl
    }
    if (router.currentRoute.query.max_syl) {
      state.preSubmissionOptions.maxSyllable = router.currentRoute.query.max_syl
    }
    if (router.currentRoute.query.max_cons) {
      state.preSubmissionOptions.maxConsonant =
        router.currentRoute.query.max_cons
    }
    if (router.currentRoute.query.pos) {
      state.morph.posIndex = router.currentRoute.query.pos
    }
    if (router.currentRoute.query.person) {
      state.morph.personIndex = router.currentRoute.query.person
    }
    if (router.currentRoute.query.status) {
      state.morph.statusIndex = router.currentRoute.query.status
    }
    if (router.currentRoute.query.num) {
      state.morph.numberIndex = router.currentRoute.query.num
    }
    if (router.currentRoute.query.gender) {
      this.$store.state.morph.genderIndex = router.currentRoute.query.gender
    }
    if (router.currentRoute.query.tense) {
      state.morph.tenseIndex = router.currentRoute.query.tense
    }
    if (router.currentRoute.query.suffix) {
      state.morph.suffixIndex = router.currentRoute.query.suffix
    }
    if (router.currentRoute.query.s_person) {
      state.morph.suffixPersonIndex = router.currentRoute.query.s_person
    }
    if (router.currentRoute.query.s_num) {
      state.morph.suffixNumberIndex = router.currentRoute.query.s_num
    }
    if (router.currentRoute.query.s_gen) {
      state.morph.suffixGenderIndex = router.currentRoute.query.s_gen
    }
    if (router.currentRoute.query.displayNames) {
      state.preSubmissionOptions.displayNames =
        router.currentRoute.query.displayNames === "true"
    }

    this.searchType = typeParam
    if (typeParam) {
      switch (typeParam) {
        case "rhyme":
        case "xxsonance":
        case "alliteration":
        case "tavnit":
          commit(StateChanges.SET_MODEL, typeParam)
          break
        case "assonance":
          commit(StateChanges.SET_MODEL, "xxsonance")
          //this.searchType = 'xxsonance'
          break
        default:
          commit(StateChanges.SET_MODEL, "rhyme")
          break
      }
    }
    if (router.currentRoute.query.tokens0) {
      const tokens = []

      for (let index = 0; index < 8; index++) {
        const queryKey = "tokens" + index

        if (queryKey in router.currentRoute.query) {
          // Check if the query parameter exists
          tokens[index] = JSON.parse(router.currentRoute.query[queryKey])
        } else {
          tokens[index] = []
        }
      }

      commit("SET_TAVNIT_PARAMS", {
        tokens: tokens,
        itemsForApi: JSON.parse(router.currentRoute.query.tavnitSearchParams),
      })
      dispatch(Actions.RUN_CHARUZIT_CALL)
    } else if (
      searchWord &&
      searchWord.length > searchWord.replace(/[^א-ת]/g, "").length
    ) {
      //Search word in url has nikud - run charuzit
      commit(StateChanges.SET_TEXT_FOR_CHARUZIT_API_CALL, searchWord)
      commit(StateChanges.SET_OVERVIEW, searchWord)
      dispatch(Actions.RUN_CHARUZIT)
    } else {
      // if(state.soundplayCallText)
      //word without nikud, run soundplay to get nikud and then run charuzit
      return new Promise((resolve, reject) => {
        commit(StateChanges.SET_SOUNDPLAY_CALL_TEXT, searchWord)
        dispatch(Actions.RUN_SOUNDPLAY).then(
          (response) => {
            if (response) {
              commit(StateChanges.SET_TEXT_FOR_CHARUZIT_API_CALL, response[0])
              if (router.currentRoute.name !== "unvocalized") {
                const redirectTo = {
                  name: "unvocalized",
                }
                router.push(redirectTo)
              }
              dispatch(Actions.RUN_CHARUZIT_CALL)
              resolve(response)
            }
          },
          (error) => {
            // http failed, let the calling function know that action did not work out
            reject(error)
          }
        )
      })
    }
    //}
  },
  [Actions.RUN_SOUNDPLAY]: function ({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit(StateChanges.SOUNDPLAY_RUNNING)
      let textForApi = state.soundplayCallText
      axiosInstance
        .post(
          SOUNDPLAY_SERVER,
          JSON.stringify({
            w: textForApi,
          })
        )
        .then((response) => {
          commit(StateChanges.SET_SOUNDPLAY_RESULTS, response.data)
          resolve(response.data)
        })
        .catch(function (error) {
          if (error.code === "ECONNABORTED") {
            commit(StateChanges.SOUNDPLAY_TIMED_OUT)
          } else {
            reject(error)
            commit(StateChanges.SOUNDPLAY_FAILED)
          }
        })
    })
  },
  [Actions.RUN_CHARUZIT]: function ({ dispatch }) {
    if (router.currentRoute.name !== "home") router.push({ name: "home" })
    dispatch(Actions.RUN_CHARUZIT_CALL)
  },
  [Actions.RUN_CHARUZIT_CALL]: function ({ commit, state }) {
    var textForApi = ""
    let searchMode =
      state.searchModel[0].toUpperCase() + state.searchModel.substring(1)
    if (state.textForCharuzitApiCall)
      textForApi = state.textForCharuzitApiCall.trim()
    var semanticKeywords = state.semanticKeywordsArr
    if (
      textForApi !== "" ||
      semanticKeywords.length > 0 ||
      (state.tavnitSearchParams.length > 0 && searchMode === "Tavnit")
    ) {
      commit(StateChanges.SET_NO_RESULTS, false)
      let typeParam = router.currentRoute.query.type
      if (typeParam === "assonance") typeParam = "xxsonance"
      var data = {
        search: textForApi,
        type: searchMode,
      }
      if (searchMode === "Xxsonance") {
        data.type = "assonance"
      }
      if (searchMode === "Tavnit") {
        data.type = "tavnit"
      }
      if (state.preSubmissionOptions.rhymeMode === "half") {
        data.mode = "half"
      }
      if (state.preSubmissionOptions.accent !== "matchinput") {
        data.accent = state.preSubmissionOptions.accent
      }
      if (!state.preSubmissionOptions.LetSwapSettings.consonentLetSwap) {
        data.consswap = "false"
      }
      if (!state.preSubmissionOptions.LetSwapSettings.vocalSwap) {
        data.vocalswap = "false"
      }
      if (state.preSubmissionOptions.minSyllable !== "1") {
        data.min_syl = state.preSubmissionOptions.minSyllable
      }
      if (state.preSubmissionOptions.maxSyllable !== "7+") {
        data.max_syl = state.preSubmissionOptions.maxSyllable
      }
      if (state.preSubmissionOptions.maxConsonant !== "2") {
        data.max_cons = state.preSubmissionOptions.maxConsonant
      }
      if (state.morph.posIndex !== 0) {
        data.pos = state.morph.posIndex
      }
      if (state.morph.personIndex !== 0) {
        data.person = state.morph.personIndex
      }
      if (state.morph.statusIndex !== 0) {
        data.status = state.morph.statusIndex
      }
      if (state.morph.numberIndex !== 0) {
        data.num = state.morph.numberIndex
      }
      if (state.morph.genderIndex !== 0) {
        data.gender = state.morph.genderIndex
      }
      if (state.morph.tenseIndex !== 0) {
        data.tense = state.morph.tenseIndex
      }
      if (state.morph.suffixIndex !== 0) {
        data.suffix = state.morph.suffixIndex
      }
      if (state.morph.suffixPersonIndex !== 0) {
        data.s_person = state.morph.suffixPersonIndex
      }
      if (state.morph.suffixNumberIndex !== 0) {
        data.s_num = state.morph.suffixNumberIndex
      }
      if (state.morph.suffixGenderIndex !== 0) {
        data.s_gen = state.morph.suffixGenderIndex
      }
      data.displayNames = state.preSubmissionOptions.displayNames
      if (semanticKeywords.length > 0) {
        var semanticArrStr = encodeURIComponent(
          JSON.stringify(semanticKeywords)
        )
        data.semantic = semanticArrStr
      }

      if (state.searchModel === "tavnit") {
        //save search in url
        data.tavnitSearchParams = JSON.stringify(state.tavnitSearchParams)
        data.tokens0 = JSON.stringify(state.patternTokens[0])
        data.tokens1 = JSON.stringify(state.patternTokens[1])
        data.tokens2 = JSON.stringify(state.patternTokens[2])
        data.tokens3 = JSON.stringify(state.patternTokens[3])
        data.tokens4 = JSON.stringify(state.patternTokens[4])
        data.tokens5 = JSON.stringify(state.patternTokens[5])
        data.tokens6 = JSON.stringify(state.patternTokens[6])
        data.tokens7 = JSON.stringify(state.patternTokens[7])

        // Remove unused parameters
        delete data.search
      }
      if (JSON.stringify(router.currentRoute.query) !== JSON.stringify(data)) {
        state.queriedData = data
        router.replace({ query: data })
      }
      if (source) {
        source.cancel()
      }
      const CancelToken = axios.CancelToken
      source = CancelToken.source()
      commit(StateChanges.CHARUZIT_RUNNING)
      //state.charuzitApiState = RunStates.RUNNING
      axiosInstance
        .post(
          CHARUZIT_SERVER,
          JSON.stringify({
            soundplay_keyword: textForApi,
            rhyme_mode: state.preSubmissionOptions.rhymeMode,
            alit_num_of_lets: parseInt(state.preSubmissionOptions.maxConsonant),
            model: searchMode,
            soundplay_settings: {
              allowletswap:
                state.preSubmissionOptions.LetSwapSettings.consonentLetSwap,
              allowvocswap:
                state.preSubmissionOptions.LetSwapSettings.vocalSwap,
            },
            semantic_keywords: semanticKeywords,
            semantic_models: "both",
            tavnit_search: state.tavnitSearchParams,
            morph_filter: {
              pos: BASEFORM_POS_LIST[state.morph.posIndex],
              person: BASEFORM_PERSON_LIST[state.morph.personIndex],
              status: BASEFORM_STATUS_LIST[state.morph.statusIndex],
              number: BASEFORM_NUMBER_LIST[state.morph.numberIndex],
              gender: BASEFORM_GENDER_LIST[state.morph.genderIndex],
              tense: BASEFORM_TENSE_LIST[state.morph.tenseIndex],
              has_suffix: SUFFIX_LIST[state.morph.suffixIndex],
              suffix_person: SUFFIX_PERSON_LIST[state.morph.suffixPersonIndex],
              suffix_number: SUFFIX_NUMBER_LIST[state.morph.suffixNumberIndex],
              suffix_gender: SUFFIX_GENDER_LIST[state.morph.suffixGenderIndex],
            },
            return_settings: {
              min_syl: parseInt(state.preSubmissionOptions.minSyllable),
              max_syl: parseInt(state.preSubmissionOptions.maxSyllable),
              accreturnsettings: state.preSubmissionOptions.accent,
              returnpropernames: state.preSubmissionOptions.displayNames,
              ignoreLoazi: !state.preSubmissionOptions.includeForeign,
              baseOnly: !state.preSubmissionOptions.includeNonBase,
            },
          }),
          { cancelToken: source.token },
          { timeout: state.searchModel === "xxsonance" ? 120000 : 30000 }
        )

        .then(function (response) {
          if (response.data.error) {
            commit(StateChanges.SET_NO_RESULTS, true)
            state.soundplayResults = []
          } else if (response.data.results) {
            if (state.searchModel == "xxsonance") {
              commit(StateChanges.SET_XX_RESULTS, response.data.results)
            } else {
              if (response.data.results[0].mode) {
                commit(
                  StateChanges.SET_CHARUZIT_RESULTS,
                  response.data.results[0]
                )
                commit(
                  StateChanges.SET_CHARUZIT_BIBLE_RESULTS,
                  response.data.results[1]
                )
                commit(
                  StateChanges.SET_COMMON_RESULTS,
                  response.data.results[2]
                )
                commit(StateChanges.SET_NS_RESULTS, response.data.results[3])
                commit(StateChanges.SET_LONG_RESULTS, response.data.results[4])
                commit(StateChanges.SET_FEM_RESULTS, response.data.results[5])
              } else {
                // Only semantic words
                state.displayOverview = false
                state.displayDefault = true
                commit(
                  StateChanges.SET_CHARUZIT_SINGLE_RESULTS,
                  response.data.results
                )
              }
            }
          } else {
            commit(StateChanges.SET_NO_RESULTS, true)
          }
          commit(StateChanges.CHARUZIT_COMPLETE)
        })
        .catch(function (thrown) {
          if (axios.isCancel(thrown)) {
            //console.log('Request cancelled')
          } else {
            commit(StateChanges.CHARUZIT_FAILED)
            //console.log('Error')
          }
          /* const timeoutStrings = ['timeout']
           if (timeoutStrings.filter(s => error.toJSON().message.toLowerCase().includes(s)).length) {              
            commit(StateChanges.CHARUZIT_TIMED_OUT)
          } else {
            commit(StateChanges.CHARUZIT_FAILED)
          } */
        })
    }
  },
}
